import type { fabric } from 'fabric';
import type { Editor } from '../editor/editor';
import { BRK, JOIN, MARKS_RE } from '../thai/segment';
import { $ } from './dom';
import { toast } from './toast';
import { addWordAndRefresh } from './dictSheet';

type EditingText = fabric.IText & { hiddenTextarea?: HTMLTextAreaElement; updateFromTextArea(): void };

/** Bar shown while editing text: manual break marks + "add selection to no-break list". */
export function initEditBar(ed: Editor) {
  const { canvas } = ed;
  canvas.on('text:editing:entered', () => { $('editbar').hidden = false; });
  canvas.on('text:editing:exited', () => { $('editbar').hidden = true; });

  const editing = (): EditingText | null => {
    const t = canvas.getActiveObject() as EditingText | null;
    return t && t.isEditing && t.hiddenTextarea ? t : null;
  };

  /* act on pointerdown and cancel the default so the hidden textarea keeps focus (keyboard stays up) */
  const hold = (id: string, fn: () => void) => {
    const b = $(id);
    b.addEventListener('mousedown', e => e.preventDefault());
    b.addEventListener('pointerdown', e => { e.preventDefault(); fn(); });
  };

  function insertMark(ch: string) {
    const t = editing();
    if (!t) { toast('แตะสองครั้งที่ข้อความ แล้ววางเคอร์เซอร์ตรงจุดที่ต้องการก่อน', true); return; }
    const ta = t.hiddenTextarea!, s = ta.selectionStart, e = ta.selectionEnd;
    if (s !== e) { toast('ตอนนี้กำลังเลือกข้อความอยู่ แตะครั้งเดียวเพื่อวางเคอร์เซอร์ตรงรอยต่อที่ต้องการ', true); return; }
    if (s === 0 || s === ta.value.length) { toast('วางเครื่องหมายที่ต้นหรือท้ายข้อความไม่มีผล ให้วางระหว่างตัวอักษร', true); return; }
    const before = ta.value[s - 1], after = ta.value[s];
    if ([before, after].some(c => c === JOIN || c === BRK)) { toast('ตรงนี้มีเครื่องหมายอยู่แล้ว ลบตัวเดิมด้วยปุ่มลบบนแป้นก่อน', true); return; }
    ta.value = ta.value.slice(0, s) + ch + ta.value.slice(s);
    ta.selectionStart = ta.selectionEnd = s + 1;
    t.updateFromTextArea(); t.initDimensions(); t.setCoords();
    canvas.fire('text:changed', { target: t } as unknown as fabric.IEvent);
    canvas.requestRenderAll();
    toast(ch === JOIN ? 'ใส่จุดห้ามตัดแล้ว (ขีดสีชมพู)' : 'ใส่จุดตัดได้แล้ว (ขีดสีเขียว)');
  }

  hold('mJoin', () => insertMark(JOIN));
  hold('mBrk', () => insertMark(BRK));
  hold('mDict', () => {
    const t = editing(); if (!t) return;
    const ta = t.hiddenTextarea!;
    const w = ta.value.slice(ta.selectionStart, ta.selectionEnd).replace(MARKS_RE, '');
    if (!w) { toast('ลากเลือกคำที่ต้องการก่อน แล้วกดปุ่มนี้อีกครั้ง', true); return; }
    void addWordAndRefresh(ed, w);
  });
  hold('mDone', () => { const t = editing(); if (t) t.exitEditing(); canvas.requestRenderAll(); });
}
